'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/prop-types/index.js');

var index$1 = require('../../../node_modules/classnames/index.js');

require('../../../node_modules/gatsby-link/index.js');

var slugify = require('../../../utilities/slugify.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var ListBlock = function ListBlock(_ref) {
  var className = _ref.className,
      dividerBottom = _ref.dividerBottom,
      dividerTop = _ref.dividerTop,
      items = _ref.items,
      target = _ref.target,
      title = _ref.title;
  var classes = index$1['default']('list-block', 'lanl-list-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-list-block"
  }, /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "sidebar-header"
  }, title), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "list-block-ul list-unstyled"
  }, items.map(function (_ref2, index) {
    var text = _ref2.text,
        url = _ref2.url;
    return /*#__PURE__*/React__default['default'].createElement("li", {
      className: "list-block-li",
      key: "list-block-".concat(slugify.slugify(title), "-").concat(index)
    }, url ? /*#__PURE__*/React__default['default'].createElement("a", {
      href: url,
      target: target
    }, text) : text);
  })));
};

ListBlock.defaultProps = {
  dividerBottom: true,
  dividerTop: true,
  items: [],
  target: '',
  title: 'Resources'
};
ListBlock.propTypes = {
  className: index['default'].string,
  dividerBottom: index['default'].bool,
  dividerTop: index['default'].bool,
  items: index['default'].arrayOf(index['default'].shape({
    text: index['default'].string.isRequired,
    url: index['default'].string
  })),
  target: index['default'].string,
  title: index['default'].string
};
exports.ListBlock = ListBlock;
exports['default'] = ListBlock;